'use client';
import { useEffect, useState } from 'react';

function useIsMobile({ size = 768 }: { size?: number } = {}) {
    // Initialize width as undefined (or null) instead of window.innerWidth
    const [width, setWidth] = useState<number | undefined>(undefined);

    useEffect(() => {
        // Only access window here, after mounting on the client
        setWidth(window.innerWidth);

        function handleWindowSizeChange() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []); // Empty dependency array since this only runs on mount/unmount

    // Only evaluate isMobile once width is defined
    const isMobile = width !== undefined ? width <= size : false;

    return isMobile;
}

export default useIsMobile;
